import BasicSlideshowV1Config from "./compositions/BasicSlideshow/v1/BasicSlideshowV1Config";
import CardGridV1Config from "./compositions/CardGrid/v1/CardGridV1Config";
import CardPileV1Config from "./compositions/CardPile/v1/CardPileV1Config";
import CommunityBlurOpenGraphV1Config from "./compositions/CommunityBlurOpenGraph/v1/CommunityBlurOpenGraphV1Config";
import FeedPreviewCardsV1Config from "./compositions/FeedPreviewCards/v1/FeedPreviewCardsV1Config";
import FlashingImagesAndWheelV1Config from "./compositions/FlashingImagesAndWheel/v1/FlashingImagesAndWheelV1Config";
import FlashingSlideshowV1Config from "./compositions/FlashingSlideshow/v1/FlashingSlideshowV1Config";
import GatheringBlurOpenGraphV1Config from "./compositions/GatheringBlurOpenGraph/v1/GatheringBlurOpenGraphV1Config";
import GatheringWheelV1Config from "./compositions/GatheringWheel/v1/GatheringWheelV1Config";
import GeneratedImageComparisonV1Config from "./compositions/GeneratedImageComparison/v1/GeneratedImageComparisonV1Config";
import GridWithStatsV1Config from "./compositions/GridWithStats/v1/GridWithStatsV1Config";
import InfoCardV1Config from "./compositions/InfoCard/v1/InfoCardV1Config";
import ListRankingV1Config from "./compositions/ListRanking/v1/ListRankingV1Config";
import PhotoV1Config from "./compositions/Photo/v1/PhotoV1Config";
import PhotosFoundGraphicV1Config from "./compositions/PhotosFoundGraphic/v1/PhotosFoundGraphicV1Config";
import PosterCardOverviewV1Config from "./compositions/PosterCardOverview/v1/PosterCardOverviewV1Config";
import ProfileV1Config from "./compositions/Profile/v1/ProfileV1Config";
import QRCodeV1Config from "./compositions/QRCode/v1/QRCodeV1Config";
import SandboxV1Config from "./compositions/Sandbox/v1/SandboxV1Config";
import ScrollingProfilesV1Config from "./compositions/ScrollingProfiles/v1/ScrollingProfilesV1Config";
import SpinningWheelSummaryV1Config from "./compositions/SpinningWheelSummary/v1/SpinningWheelSummaryV1Config";
import SpiralSlideshowV1Config from "./compositions/SpiralSlideshow/v1/SpiralSlideshowV1Config";
import StaticSandboxV1Config from "./compositions/StaticSandbox/v1/StaticSandboxV1Config";
import TitledImageRowsV1Config from "./compositions/TitledImageRows/v1/TitledImageRowsV1Config";
import TitledImageStackV1Config from "./compositions/TitledImageStack/v1/TitledImageStackV1Config";
import UserHighlightCardsV1Config from "./compositions/UserHighlightCards/v1/UserHighlightCardsV1Config";
import ZoomedWheelV1Config from "./compositions/ZoomedWheel/v1/ZoomedWheelV1Config";
import { CompositionConfigLight } from "./types";

/**
 * Light version of the Compositions object. Used to avoid importing all of the Skia stuff.
 */
const CompositionsLight = {
	SandboxV1: SandboxV1Config,
	BasicSlideshowV1: BasicSlideshowV1Config,
	SpiralSlideshowV1: SpiralSlideshowV1Config,
	StaticSandboxV1: StaticSandboxV1Config,
	GatheringBlurOpenGraphV1: GatheringBlurOpenGraphV1Config,
	ScrollingProfilesV1: ScrollingProfilesV1Config,
	CommunityBlurOpenGraphV1: CommunityBlurOpenGraphV1Config,
	GatheringWheelV1: GatheringWheelV1Config,
	ZoomedWheelV1: ZoomedWheelV1Config,
	QRCodeV1: QRCodeV1Config,
	FlashingSlideshowV1: FlashingSlideshowV1Config,
	PhotoV1: PhotoV1Config,
	ProfileV1: ProfileV1Config,
	FlashingImagesAndWheelV1: FlashingImagesAndWheelV1Config,
	InfoCardV1: InfoCardV1Config,
	PosterCardOverviewV1: PosterCardOverviewV1Config,
	TitledImageStackV1: TitledImageStackV1Config,
	TitledImageRowsV1: TitledImageRowsV1Config,
	CardGridV1: CardGridV1Config,
	CardPileV1: CardPileV1Config,
	ListRankingV1: ListRankingV1Config,
	GridWithStatsV1: GridWithStatsV1Config,
	UserHighlightCardsV1: UserHighlightCardsV1Config,
	SpinningWheelSummaryV1: SpinningWheelSummaryV1Config,
	FeedPreviewCardsV1: FeedPreviewCardsV1Config,
	PhotosFoundGraphicV1: PhotosFoundGraphicV1Config,
	GeneratedImageComparisonV1: GeneratedImageComparisonV1Config,
} satisfies Record<string, CompositionConfigLight<any>>;

export type CompositionsLightType = typeof CompositionsLight;
export type CompositionKey = keyof typeof CompositionsLight;

export default CompositionsLight;
